// extracted by mini-css-extract-plugin
export default {"root":"SVGDefs-root_S32Xw"};